// extracted by mini-css-extract-plugin
export var calendarView = "_mz-0";